/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get("back-to-top")) {
    class BackToTop extends HTMLElement {
      constructor() {
        super();
      }
  
      connectedCallback() {
        this.addEventListener("click", this.onClick);
        window.addEventListener("scroll", this.checkScrollDepth.bind(this));
      }
  
      checkScrollDepth(event) {
        window.requestAnimationFrame(() => {
          let y = window.scrollY;
          if (y > 0) {
            this.classList.add("back-to-top--active");
          } else {
            this.classList.remove("back-to-top--active");
          }
        });
      }
  
      onClick() {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }
    }
    customElements.define("back-to-top", BackToTop);
  }
  